import { PreloaderService } from './../_services/Preloader.service';
import { EnrollService } from '../_services/_EnrollServices/Enroll.service';
import { Component, OnInit } from '@angular/core';
import { ToasterService } from '../_services/Toaster.service';
import { EnrollView } from '../_models/EnrollView';
import { Subscription, interval } from 'rxjs';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-Real-Time_Enroll_View',
  templateUrl: './Real-Time_Enroll_View.component.html',
  styleUrls: ['./Real-Time_Enroll_View.component.css']
})
// tslint:disable-next-line: class-name
export class RealTime_Enroll_ViewComponent implements OnInit {

  DateTime:any;
  Enroll: EnrollView[];
  private updateSubscription: Subscription;



  constructor(
    private EnrollService: EnrollService,
    private noti: ToasterService,
    private preloader: PreloaderService) { }

  ngOnInit() {
    var today = new Date();
    var date = (today.getMonth()+1)+'/'+today.getDate()+'/'+ today.getFullYear()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    this.DateTime=date;
    this.updateSubscription = interval(1000).subscribe(
      (val) => {
        this.LoadEnroll(this.DateTime);
      }
    );
  }

  ngAfterViewInit() {
    this.preloader.hide();
  }

  LoadEnroll(DateTime:any) {
    this.EnrollService.GetOverAllDeviceStatus(DateTime).subscribe(
      Response => {
        if(Response.status==200)
        {
        this.Enroll =  Response.body;
        }


      },
      (error) => {

      }
    );
  }
}
